var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-magic"},[(_vm.magicUrl)?_c('iframe',{staticClass:"magic-iframe",attrs:{"src":_vm.magicUrl,"frameborder":"0"}}):_vm._e(),_c('section',{staticClass:"magic-iframe"},[_c('el-empty',{attrs:{"description":"出错了"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }